import { useDispatch, useSelector } from 'react-redux';
import { usePubNub } from 'pubnub-react';

import {
  setCurrentContact,
  allContactsSelector,
  currentContactSelector,
} from 'app/features/chat/nfChatSlice';

const useChatFunctions = () => {
  const dispatch = useDispatch();
  const allContacts = useSelector(state => allContactsSelector(state));
  const oldContact = useSelector(state => currentContactSelector(state));
  const pubNubClient = usePubNub();

  const genericPubNubListener = (message, fun) => {
    // eslint-disable-next-line no-console
    console.log('message', message);

    if (fun) fun(message);
  };

  const subscribe = (contact) => {
    if (!contact) return;

    pubNubClient.subscribe({ channels: [contact.other_user.public_channel_name] });
    pubNubClient.addListener({ message: genericPubNubListener });
  };

  const unsubscribe = (contact) => {
    if (!contact) return;

    pubNubClient.unsubscribe({ channels: [contact.other_user.public_channel_name] });
    pubNubClient.removeListener(genericPubNubListener);
  };

  const setCurrentContactBySlugAndSubscribe = (slug) => {
    if (allContacts?.length === 0) return;

    if (oldContact) unsubscribe(oldContact);

    let newContact = allContacts.find((contact) => {
      return contact.other_user.slug === slug;
    });

    if (newContact) {
      window.history.pushState({}, '', `/chat/${newContact.other_user.slug}`);
      dispatch(setCurrentContact({ contact: newContact }));
    } else {
      [newContact] = allContacts;
      window.history.pushState({}, '', `/chat/${newContact.other_user.slug}`);
      dispatch(setCurrentContact({ contact: newContact }));
    }

    if (newContact) subscribe(newContact);
  };

  return {
    setCurrentContactBySlugAndSubscribe,
    pubNubClient,
    genericPubNubListener,
  };
};

export default useChatFunctions;
